import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import { Col, Row, Form, Space, Typography, Divider, Button, Spin } from 'antd';
//import CustomButton from '@/common/CustomButton';
import FormItem from 'common/FormItem';
import RejectModal from '../RejectModal';
import ApproveModal from '../ApproveModal';
import GPModal from '../GPModal';
import ItemsModal from '../ItemsModal';
import HoModal from '../hoModal';
import moment from 'moment';
import { getLoggedInUser } from 'utilities/helpers';
import { ArrowLeftOutlined } from '@ant-design/icons';

const ViewDetails_SAP = ({
  requester_data1,
  //requester_data_Approver1,
  gatepassItems,
  getRequestByIdLoading,
  itemsPagination,
  page,
  setPage,
  pageSize,
  setPageSize
}) => {
  const [requester_data, setRequester_data] = useState();

  useEffect(() => {
    setRequester_data(requester_data1);
  }, [requester_data1]);

  console.log('requester_data', requester_data);

  const onFinish = (values) => {
    console.log('Values', values);
  };

  // const params = useParams();
  const user = getLoggedInUser();
  const role =
    user?.user_details?.roles?.length > 0 ? user?.user_details?.roles[0] : '';

  const [form] = Form.useForm();
  const [rejectModal, setRejectModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [itemsModal, setItemsModal] = useState(false);
  const [vehicleFormValue, setVehicleFormValue] = useState({});
  const [hoModal, setHoModal] = useState(false);

  console.log('vehicleFormValue', vehicleFormValue);
  console.log('user', user?.user_details);

  const handleFetchDocument = (fileName) => {
    window?.open(
      `${process.env.REACT_APP_API_URL}/fetch-file?fileName=${fileName}`,
      '_blank'
    );
  };

  return (
    <>
      <Spin spinning={getRequestByIdLoading}>
        <div className={`mb-4 ${styles.container}`}>
          <Row gutter={16} style={{ marginTop: '-9px' }}>
            <Col span={21}>
              <div className={`${styles.page_title1}`}>
                <span style={{ fontSize: '18px' }}>Ticket no:</span>

                <span style={{ fontSize: '18px', marginLeft: '5px' }}>
                  {requester_data ? requester_data?.ticket : 'NA'}
                </span>
                <span style={{ fontSize: '18px', marginLeft: '20px' }}>
                  Gate Pass no:
                </span>
                <span style={{ fontSize: '18px', marginLeft: '5px' }}>
                  {requester_data ? requester_data?.gp_number : 'NA'}
                </span>
              </div>
              <div className={`${styles.page_sub_title}`}>
                Please review it and take action
              </div>
            </Col>
            <Col span={2} style={{ marginLeft: '20px' }}>
              {role === 'requester' ? (
                <a href={'/requesters-sap-dashboard'}>
                  <Button className={`${styles.back_button}`}>
                    <ArrowLeftOutlined className={`${styles.back_icon}`} />
                    Back
                  </Button>
                </a>
              ) : role === 'ho' ? (
                <a href={'/ho-requests_sap'}>
                  <Button className={`${styles.back_button}`}>
                    <ArrowLeftOutlined className={`${styles.back_icon}`} />
                    Back
                  </Button>
                </a>
              ) : role === 'issuer' ? (
                <a href={'/dashboard-issuer-sap'}>
                  <Button className={`${styles.back_button}`}>
                    <ArrowLeftOutlined className={`${styles.back_icon}`} />
                    Back
                  </Button>
                </a>
              ) : (
                <a href={'/dashboard-approver-sap'}>
                  <Button className={`${styles.back_button}`}>
                    <ArrowLeftOutlined className={`${styles.back_icon}`} />
                    Back
                  </Button>
                </a>
              )}
            </Col>
          </Row>
          <br />
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            className={`${styles.formstyles}`}
          >
            <Row gutter={16}>
              <Col span={6}>
                <FormItem label="Plant" className={`${styles.select_styles}`}>
                  <Typography>
                    {requester_data?.SapPlantId === null
                      ? ''
                      : `${requester_data?.SapPlant?.plant_code}(${requester_data?.SapPlant?.plant_name}) `}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Storage Location"
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data?.SapStorageLocationId === null
                      ? ''
                      : `${requester_data?.SapStorageLocation?.code} (${requester_data?.SapStorageLocation?.name})`}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="Type" className={`${styles.select_styles}`}>
                  <Typography>
                    {requester_data?.SapTypeMasterId === null
                      ? ''
                      : requester_data?.SapTypeMaster?.type}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Category"
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data?.SapCategoryMasterId === null
                      ? ''
                      : requester_data?.SapCategoryMaster?.category}
                  </Typography>
                </FormItem>
              </Col>
            </Row>
            {requester_data?.SapMethodTypeMaster?.method_type === 'SAP' ? (
              <>
                <Divider
                  style={{
                    margin: 0,
                    marginTop: '10px',
                    marginBottom: '25px'
                  }}
                />
                <Row gutter={16}>
                  <Col span={6}>
                    <FormItem
                      label="Reference documents"
                      className={`${styles.select_styles}`}
                    >
                      <Typography>
                        {requester_data?.SapDocumentMaster?.document_name}
                      </Typography>
                    </FormItem>
                  </Col>
                  <Col span={6}>
                    <FormItem
                      label="Year"
                      className={`${styles.select_styles}`}
                    >
                      <Typography>
                        {requester_data
                          ? requester_data?.year === null
                            ? 'NA'
                            : requester_data?.year //moment(requester_data?.year).format('YYYY')
                          : 'NA'}
                      </Typography>
                    </FormItem>
                  </Col>
                  <Col span={6}>
                    <FormItem
                      label="Reference number"
                      className={`${styles.select_styles}`}
                    >
                      <Typography>
                        {requester_data?.SapDocumentMasterId !== null
                          ? requester_data?.document_number
                          : 'NA'}
                      </Typography>
                    </FormItem>
                  </Col>
                </Row>
              </>
            ) : (
              ''
            )}
            <Divider
              style={{
                // margin: 0,
                marginTop: '10px',
                marginBottom: '15px'
              }}
            />
            <Row gutter={16}>
              <Col span={6}>
                <FormItem label="Method" className={`${styles.select_styles}`}>
                  <Typography>
                    {requester_data?.SapMethodTypeMasterId === null
                      ? ''
                      : requester_data?.SapMethodTypeMaster?.method_type}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label={
                    requester_data?.Document_master?.id === 3
                      ? 'Project name'
                      : 'Vendor name'
                  }
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data
                      ? requester_data?.VendorMasterId === null
                        ? requester_data?.Vendor_Master?.vendorName
                        : requester_data?.Vendor_Master?.vendorCode === null &&
                          requester_data?.Vendor_Master?.vendorName !== null
                        ? requester_data?.Vendor_Master?.vendorName
                        : requester_data?.Vendor_Master?.vendorCode === null &&
                          requester_data?.Vendor_Master?.vendorName === null
                        ? 'NA'
                        : `${requester_data?.Vendor_Master?.vendorName} (${requester_data?.Vendor_Master?.vendorCode})`
                      : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label={'Vendor location'}
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data ? (
                      <>
                        {/* <span>{requester_data?.Vendor_Master?.city}</span>{' '}
                      <span>{requester_data?.Vendor_Master?.state}</span>{' '} */}
                        <span>{requester_data?.vendor_location_name}</span>{' '}
                      </>
                    ) : (
                      'NA'
                    )}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="Address" className={`${styles.select_styles}`}>
                  <Typography className={`${styles.addr_typo}`}>
                    {requester_data?.vendor_location_address
                      ? requester_data?.vendor_location_address
                      : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
            </Row>
            <Divider
              style={{
                //margin: 0,
                marginTop: '10px',
                marginBottom: '15px'
              }}
            />
            <Row gutter={16}>
              <Col span={6}>
                <FormItem
                  label="Generated date"
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data?.date_of_generated === null
                      ? 'NA'
                      : moment(requester_data?.date_of_generated).format(
                          'DD MMM YYYY'
                        )}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Material belongs to"
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data
                      ? requester_data?.SapMaterialBelongsMaster?.material_name
                      : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
              {requester_data?.SapCategoryMaster?.category ===
              'Returnable Gate Pass (RGP)' ? (
                <>
                  {/* // 'Returnable Gate Pass (RGP)' */}
                  <Col span={6}>
                    <FormItem
                      label="Expected date of return"
                      className={`${styles.select_styles}`}
                    >
                      <Typography>
                        {requester_data
                          ? requester_data?.expected_date_return === null
                            ? 'NA'
                            : moment(
                                requester_data?.expected_date_return
                              ).format('DD MMM YYYY')
                          : 'NA'}
                      </Typography>
                    </FormItem>
                  </Col>

                  <Col span={6}>
                    <FormItem
                      label="Actual return date"
                      className={`${styles.select_styles}`}
                    >
                      <Typography>
                        {requester_data
                          ? requester_data?.actual_return_date === null
                            ? 'NA'
                            : moment(requester_data?.actual_return_date).format(
                                'DD MMM YYYY'
                              )
                          : 'NA'}
                      </Typography>
                    </FormItem>
                  </Col>
                </>
              ) : (
                ''
              )}
            </Row>
            <Divider
              style={{
                //margin: 0,
                marginTop: '10px',
                marginBottom: '15px'
              }}
            />
            <Row gutter={16}>
              <Col span={6}>
                <FormItem
                  label="Vehicle number"
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data ? requester_data?.vehicle_number : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="LR number"
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data ? requester_data?.lr_number : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="LR Date" className={`${styles.select_styles}`}>
                  <Typography>
                    {requester_data
                      ? requester_data?.lr_date === null
                        ? 'NA'
                        : moment(requester_data?.lr_date).format('DD MMM YYYY')
                      : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Name of the carrier person"
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data
                      ? requester_data?.carrier_person_name
                      : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
            </Row>
            <Divider
              style={{
                // margin: 0,
                marginTop: '10px',
                marginBottom: '15px'
              }}
            />
            <Row gutter={16}>
              <Col span={6}>
                <FormItem
                  label="Requester"
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data?.User
                      ? `${requester_data?.User?.first_name}(${requester_data?.User?.email})`
                      : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Approver"
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data?.SapApprovers?.length > 0
                      ? requester_data?.SapApprovers[0]?.User?.email
                      : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem label="Issuer" className={`${styles.select_styles}`}>
                  <Typography>
                    {requester_data?.SapApprovers?.length > 0
                      ? requester_data?.SapApprovers[1]?.User?.email
                      : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="GST Number"
                  className={`${styles.select_styles}`}
                >
                  <Typography>
                    {requester_data ? requester_data?.SapPlant?.gst : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
            </Row>
            <Divider
              style={{
                margin: 0,
                marginTop: '10px',
                marginBottom: '10px'
              }}
            />

            <a
              className={`${styles.itemsDetails}`}
              // htmlType="submit"
              size="small"
              onClick={() => setItemsModal(true)}
            >
              Item Details
            </a>
            <br />

            <Divider
              style={{
                margin: 0,
                marginBottom: '15px',
                marginTop: '15px'
              }}
            />
            <Row gutter={16}>
              <Col span={6}>
                <FormItem
                  label="Reason for sending"
                  className={`${styles.select_styles}`}
                >
                  <Typography className={`${styles.addr_typo}`}>
                    {requester_data
                      ? requester_data?.SapReasonToSendMaster?.reason_name
                      : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Detailed reason"
                  className={`${styles.select_styles}`}
                >
                  <Typography className={`${styles.addr_typo}`}>
                    {requester_data ? requester_data?.detailed_reason : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
              {requester_data?.status === 'Rejected' ? (
                <Col span={6}>
                  <FormItem
                    label="Reason for rejection"
                    className={`${styles.select_styles}`}
                  >
                    <Typography className={`${styles.addr_typo}`}>
                      {requester_data?.reason_for_rejection !== null
                        ? requester_data?.reason_for_rejection
                        : 'NA'}
                    </Typography>
                  </FormItem>
                </Col>
              ) : (
                ''
              )}
              <Col span={6}>
                <FormItem label="Remarks" className={`${styles.select_styles}`}>
                  <Typography className={`${styles.addr_typo}`}>
                    {requester_data?.remarks !== null
                      ? requester_data?.remarks
                      : 'NA'}
                  </Typography>
                </FormItem>
              </Col>
            </Row>
            <Divider
              style={{
                margin: 0,
                marginTop: '10px',
                marginBottom: '10px'
              }}
            />

            <div
              style={{
                fontWeight: 550,
                color: 'rgba(0, 0, 0, 0.85)',
                fontSize: '13px',
                marginBottom: '20px',
                flexDirection: 'row'
              }}
            >
              <Row>
                <Col>
                  <span style={{ fontWeight: '500' }}>
                    {' '}
                    Uploaded documents:
                  </span>
                </Col>
                <Col>
                  <ul style={{ marginLeft: '-20px' }}>
                    {requester_data?.SapDocuments?.map((item, index) => (
                      <li
                        className={`${styles.li_style}`}
                        style={{ marginRight: '20px' }}
                        key={index}
                      >
                        {/* <a
                          href={item?.fileUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {item?.originalName}
                        </a> */}
                        <Button
                          type="link"
                          onClick={() => {
                            handleFetchDocument(item?.fileName);
                          }}
                        >
                          {item?.originalName}
                        </Button>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            </div>
            {/*  ) : (
            ''
          )} */}
            <Divider
              style={{
                margin: 0,
                marginTop: '250px !important',
                marginBottom: '25px'
              }}
            />

            <FormItem>
              <Space>
                {role === 'approver' &&
                requester_data?.status === 'Requested' ? (
                  <Button
                    className={`${styles.success_viewDetail_button}`}
                    htmlType="submit"
                    size="small"
                    onClick={() => setApproveModal(true)}
                  >
                    Approve
                  </Button>
                ) : role === 'issuer' &&
                  requester_data?.status === 'Approved' ? (
                  // statusApprove?.status === 'Pending'
                  <Button
                    className={`${styles.success_viewDetail_button}`}
                    htmlType="submit"
                    size="small"
                    onClick={() => setApproveModal(true)}
                  >
                    Initiate Gate Pass
                  </Button>
                ) : role === 'ho' && requester_data?.status == 'Printed' ? (
                  <Button
                    className={`${styles.success_viewDetail_button}`}
                    htmlType="submit"
                    size="small"
                    onClick={() => setHoModal(true)}
                  >
                    Change to Gate Pass Generated
                  </Button>
                ) : (
                  ''
                )}

                {role === 'approver' &&
                requester_data?.status == 'Requested' ? (
                  <Button
                    className={`${styles.import_style_danger}`}
                    htmlType="submit"
                    size="small"
                    onClick={() => setRejectModal(true)}
                  >
                    Reject
                  </Button>
                ) : role === 'issuer' &&
                  requester_data?.status === 'Approved' ? (
                  // statusApprove?.status == 'Pending'
                  <Button
                    className={`${styles.import_style_danger}`}
                    htmlType="submit"
                    size="small"
                    onClick={() => setRejectModal(true)}
                  >
                    Reject
                  </Button>
                ) : role === 'ho' && requester_data?.status === 'Generated' ? ( //|| requester_data?.status === 'Approved'
                  <Button
                    className={`${styles.import_style_danger}`}
                    htmlType="submit"
                    size="small"
                    onClick={() => setRejectModal(true)}
                  >
                    Cancel Gate Pass
                  </Button>
                ) : role === 'ho' && requester_data?.status === 'Approved' ? (
                  <Button
                    className={`${styles.import_style_danger}`}
                    htmlType="submit"
                    size="small"
                    onClick={() => setRejectModal(true)}
                  >
                    Cancel Gate Pass
                  </Button>
                ) : (
                  ''
                )}
              </Space>
            </FormItem>
          </Form>
          {rejectModal ? (
            <RejectModal
              rejectModal={rejectModal}
              setRejectModal={setRejectModal}
              requester_data={requester_data}
              role={role}
            />
          ) : (
            ''
          )}
          {approveModal ? (
            role === 'approver' ? (
              <ApproveModal
                approveModal={approveModal}
                setApproveModal={setApproveModal}
              />
            ) : role === 'issuer' ? (
              <GPModal
                approveModal={approveModal}
                setApproveModal={setApproveModal}
                requester_data={requester_data}
                vehicleFormValue={vehicleFormValue}
                setVehicleFormValue={setVehicleFormValue}
                ItemsDetails={gatepassItems}
              />
            ) : (
              ''
            )
          ) : (
            ''
          )}
          {itemsModal ? (
            <ItemsModal
              itemsModal={itemsModal}
              setItemsModal={setItemsModal}
              requester_data={requester_data}
              gatepassItems={gatepassItems}
              itemsPagination={itemsPagination}
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
            />
          ) : (
            ''
          )}
          {hoModal ? (
            role === 'ho' ? (
              <HoModal
                hoModal={hoModal}
                setHoModal={setHoModal}
                requester_data={requester_data}
              />
            ) : (
              ''
            )
          ) : (
            ''
          )}
        </div>
      </Spin>
    </>
  );
};

export default ViewDetails_SAP;
